import React, { Fragment, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import PageTitle from "../layouts/PageTitle";
import { Formik } from "formik";
import * as Yup from "yup";
import { Fn_AddEditData, Fn_DisplayData, Fn_FillListData, Fn_DeleteData } from "../../store/Functions";
import { useDispatch } from "react-redux";
import { API_WEB_URLS } from "../../constants/constAPI";
import { toast } from "react-toastify";
import { isNotInUse } from "../utils/masterFilters";

const FirmSchema = Yup.object().shape({
  Name: Yup.string().required("Firm name is required"),
  F_FirmType: Yup.string().required("Firm type is required"),
});

const emptyBranchRow = (isMain = false) => ({
  _uid: `b_${Date.now()}_${Math.random().toString(36).substring(2, 7)}`,
  Id: 0,
  Name: "",
  CoAddress: "",
  CoOtherAddress: "",
  OfficeAddress: "",
  OfficeAddressOther: "",
  PhoneMobileNo: "",
  IsMainBranch: isMain ? 1 : 0,
  CentralRuleMinWages: 0,
  PFNo: "",
  ESINo: "",
  LINNo: "",
  FBRegNo: "",
  RegRenDate: "",
  RegExpiryDate: "",
  Connection: "",
  FirmNameHindi: "",
  FirmAddressHindi: "",
  ManagerName: "",
  ManagerAddress: "",
  IsContractor: 0,
  PrincipleEmployer: "",
  PrincipleEmployerAddress: "",
  PFUserName: "",
  PFPassword: "",
  ESIUserName: "",
  ESIPassword: "",
  FactoryActUserName: "",
  FactoryActPassword: "",
  EmploymentUserName: "",
  EmploymentPassword: "",
  LabourUserName: "",
  LabourPassword: "",
  OSHUserName: "",
  OSHPassword: "",
  ShramSuvidhaUserName: "",
  ShramSuvidhaPassword: "",
  SSOUserName: "",
});

const getDaysInMonth = (monthVal) => {
  const m = Number(monthVal);
  if (!m || isNaN(m)) return 31;
  if (m === 2) return 29; // February (up to 29 for leap/annual cycles)
  if ([4, 6, 9, 11].includes(m)) return 30; // April, June, September, November
  return 31; // January, March, May, July, August, October, December
};

const processImageToLogo = (file) => {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = 75;
        canvas.height = 75;
        const ctx = canvas.getContext("2d");
        
        // Calculate crop parameters for 1:1 aspect ratio (center crop)
        const size = Math.min(img.width, img.height);
        const x = (img.width - size) / 2;
        const y = (img.height - size) / 2;
        
        // Draw cropped center of image scaled to 75x75 onto canvas
        ctx.drawImage(img, x, y, size, size, 0, 0, 75, 75);
        
        // Convert canvas to blob/file
        canvas.toBlob((blob) => {
          if (blob) {
            const processedFile = new File([blob], file.name, { type: file.type || "image/jpeg" });
            resolve({
              file: processedFile,
              previewUrl: canvas.toDataURL(file.type || "image/jpeg")
            });
          } else {
            resolve({ file, previewUrl: e.target.result });
          }
        }, file.type || "image/jpeg", 0.95);
      };
      img.src = e.target.result;
    };
    reader.readAsDataURL(file);
  });
};

const AddEdit_FirmMaster = () => {
  const [activeTab, setActiveTab] = useState("mainInfo");
  const [branchRows, setBranchRows] = useState([emptyBranchRow(true)]);
  const [isMultiPF, setIsMultiPF] = useState(false);
  const [isMultiESI, setIsMultiESI] = useState(false);

  const [state, setState] = useState({
    id: 0,
    formData: {
      // Main Information
      Name: "",
      F_FirmType: "",
      PFNo: "",
      ESINo: "",
      NatureOfBusiness: "",
      Signature: "",
      PFUserName: "",
      PFPassword: "",
      ESIUserName: "",
      ESIPassword: "",
      FactoryActUserName: "",
      FactoryActPassword: "",
      EmploymentUserName: "",
      EmploymentPassword: "",
      LabourUserName: "",
      LabourPassword: "",
      OSHUserName: "",
      OSHPassword: "",
      ShramSuvidhaUserName: "",
      ShramSuvidhaPassword: "",
      SSOUserName: "",
      SSOPassword: "",
      IsNotInUse: false,

      // Manager Information
      ManagerName: "",
      ManagerAddress: "",
      IsContractor: false,
      PrincipleEmployer: "",
      PrincipleEmployerAddress: "",

      // Address
      CoAddress: "",
      CoOtherAddress: "",
      OfficeAddress: "",
      OfficeAddressOther: "",
      PhoneMobileNo: "",

      // Information
      MaxWorkers: "",
      UseOfPower: "",
      F_ConcernType: "",
      F_PremisesType: "",
      AmendmentFee: "",
      DuplicateLicenceFee: "",
      LINNo: "",
      LicenceFee: "",
      DifferenceFee: "",
      Connection: "",
      RegRenDate: "",
      RegExpiryDate: "",
      FBRegNo: "",
      InTime: "",
      OutTime: "",
      CentralRuleMinWages: false,
      Remark: "",

      // Firm In Hindi
      FirmNameHindi: "",
      FirmAddressHindi: "",

      // Additional
      CalenderFromDay: "",
      CalenderFromMonth: "",
      CalenderToDay: "",
      CalenderToMonth: "",
      Logo: "",
      LogoPreview: "",
      LogoFile: null,
    },
    FirmType: [],
    ConcernType: [],
    PremisesType: [],
    isProgress: true,
  });

  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const API_URL_SAVE = "FirmMaster/0/token";
  const API_URL_EDIT = `${API_WEB_URLS.MASTER}/0/token/FirmMaster/Id`;

  useEffect(() => {
    Fn_FillListData(dispatch, setState, "FirmType", `${API_WEB_URLS.MASTER}/0/token/FirmTypeMaster/Id/0`);
    Fn_FillListData(dispatch, setState, "ConcernType", `${API_WEB_URLS.MASTER}/0/token/ConcernTypeMaster/Id/0`);
    Fn_FillListData(dispatch, setState, "PremisesType", `${API_WEB_URLS.MASTER}/0/token/PremisesTypeMaster/Id/0`);

    const Id = (location.state && location.state.Id) || 0;
    if (Id > 0) {
      setState((prev) => ({ ...prev, id: Id }));
      const fetchData = async () => {
        const res = await Fn_DisplayData(dispatch, setState, Id, API_URL_EDIT);
        console.log("Fetched FirmMaster data:", res.dataList[0]);
      };
      fetchData();
    }

    // Check Multi PF and Multi ESI from PayrollParameter for this firm
    const sessionFirm = JSON.parse(localStorage.getItem("selectedFirm") || "{}");
    const targetFirmId = Id > 0 ? Id : (sessionFirm?.Id || 0);
    if (targetFirmId > 0) {
      Fn_FillListData(
        dispatch,
        () => {},
        "Data",
        `${API_WEB_URLS.MASTER}/0/token/PayrollParameter/TBL.F_FirmMaster/${targetFirmId}`
      )
        .then((params) => {
          if (params && params.length > 0) {
            setIsMultiPF(Boolean(params[0].IsMultiPF));
            setIsMultiESI(Boolean(params[0].IsMultiESI));
          } else {
            setIsMultiPF(false);
            setIsMultiESI(false);
          }
        })
        .catch((err) => {
          console.error("Error fetching PayrollParameter:", err);
          setIsMultiPF(false);
          setIsMultiESI(false);
        });
    } else {
      setIsMultiPF(false);
      setIsMultiESI(false);
    }
  }, [dispatch, location.state]);

  // Populate branch rows when editing
  useEffect(() => {
    if (!state.formData?.BranchData) return;

    try {
      const parsed = JSON.parse(state.formData.BranchData);
      if (Array.isArray(parsed) && parsed.length > 0) {
        // Identify which branch is explicitly marked as main (default to first if none)
        const mainIdx = parsed.findIndex(b => Boolean(b.IsMainBranch === 1 || b.IsMainBranch === true || b.IsMainBranch === "1"));
        const effectiveMainIdx = mainIdx >= 0 ? mainIdx : 0;

        // Keep natural branch order as in DB, ensure exactly ONE is Main Branch
        setBranchRows(parsed.map((b, idx) => {
          const isThisMain = idx === effectiveMainIdx;
          return {
            ...b,
            _uid: b.Id ? `b_${b.Id}` : `new_${idx}_${Math.random().toString(36).substring(2, 7)}`,
            IsMainBranch: isThisMain ? 1 : 0,
            RegRenDate: isThisMain ? (b.RegRenDate || state.formData?.RegRenDate || "") : (b.RegRenDate || ""),
            RegExpiryDate: isThisMain ? (b.RegExpiryDate || state.formData?.RegExpiryDate || "") : (b.RegExpiryDate || ""),
            PFNo: isThisMain ? (b.PFNo || state.formData?.PFNo || "") : (b.PFNo || ""),
            ESINo: isThisMain ? (b.ESINo || state.formData?.ESINo || "") : (b.ESINo || ""),
            PFUserName: isThisMain ? (b.PFUserName || state.formData?.PFUserName || "") : (b.PFUserName || ""),
            PFPassword: isThisMain ? (b.PFPassword || state.formData?.PFPassword || "") : (b.PFPassword || ""),
            ESIUserName: isThisMain ? (b.ESIUserName || state.formData?.ESIUserName || "") : (b.ESIUserName || ""),
            ESIPassword: isThisMain ? (b.ESIPassword || state.formData?.ESIPassword || "") : (b.ESIPassword || ""),
            FactoryActUserName: isThisMain ? (b.FactoryActUserName || state.formData?.FactoryActUserName || "") : (b.FactoryActUserName || ""),
            FactoryActPassword: isThisMain ? (b.FactoryActPassword || state.formData?.FactoryActPassword || "") : (b.FactoryActPassword || ""),
            EmploymentUserName: isThisMain ? (b.EmploymentUserName || state.formData?.EmploymentUserName || "") : (b.EmploymentUserName || ""),
            EmploymentPassword: isThisMain ? (b.EmploymentPassword || state.formData?.EmploymentPassword || "") : (b.EmploymentPassword || ""),
            LabourUserName: isThisMain ? (b.LabourUserName || state.formData?.LabourUserName || "") : (b.LabourUserName || ""),
            LabourPassword: isThisMain ? (b.LabourPassword || state.formData?.LabourPassword || "") : (b.LabourPassword || ""),
            OSHUserName: isThisMain ? (b.OSHUserName || state.formData?.OSHUserName || "") : (b.OSHUserName || ""),
            OSHPassword: isThisMain ? (b.OSHPassword || state.formData?.OSHPassword || "") : (b.OSHPassword || ""),
            ShramSuvidhaUserName: isThisMain ? (b.ShramSuvidhaUserName || state.formData?.ShramSuvidhaUserName || "") : (b.ShramSuvidhaUserName || ""),
            ShramSuvidhaPassword: isThisMain ? (b.ShramSuvidhaPassword || state.formData?.ShramSuvidhaPassword || "") : (b.ShramSuvidhaPassword || ""),
            SSOUserName: isThisMain ? (b.SSOUserName || state.formData?.SSOUserName || "") : (b.SSOUserName || ""),
            SSOPassword: isThisMain ? (b.SSOPassword || state.formData?.SSOPassword || "") : (b.SSOPassword || ""),
            CentralRuleMinWages: b.CentralRuleMinWages ? 1 : 0,
            IsContractor: b.IsContractor ? 1 : 0,
          };
        }));
      }
    } catch (_) {}
  }, [state.formData?.BranchData, state.formData?.PFNo, state.formData?.ESINo, state.formData?.PFUserName, state.formData?.PFPassword, state.formData?.ESIUserName, state.formData?.ESIPassword, state.formData?.FactoryActUserName, state.formData?.FactoryActPassword, state.formData?.EmploymentUserName, state.formData?.EmploymentPassword, state.formData?.LabourUserName, state.formData?.LabourPassword, state.formData?.OSHUserName, state.formData?.OSHPassword, state.formData?.ShramSuvidhaUserName, state.formData?.ShramSuvidhaPassword, state.formData?.SSOUserName, state.formData?.SSOPassword]);

  // Branch table handlers
  const addBranchRow = () => setBranchRows((prev) => [...prev, emptyBranchRow(false)]);

  const setAsMainBranch = (uid, currentFirmValues) => {
    setBranchRows((prev) =>
      prev.map((b) => {
        if (b._uid === uid) {
          return {
            ...b,
            IsMainBranch: 1,
            RegRenDate: b.RegRenDate || currentFirmValues?.RegRenDate || "",
            RegExpiryDate: b.RegExpiryDate || currentFirmValues?.RegExpiryDate || "",
          };
        }
        return { ...b, IsMainBranch: 0 };
      })
    );
  };

  const removeBranchRow = (uid) => {
    setBranchRows((prev) => {
      if (prev.length <= 1) {
        toast.warning("A firm must have at least one branch.");
        return prev;
      }
      const target = prev.find((b) => b._uid === uid);
      if (target?.IsMainBranch === 1) {
        toast.warning("Main branch cannot be deleted. Please select another branch as Main Branch first.");
        return prev;
      }
      const filtered = prev.filter((b) => b._uid !== uid);
      toast.success("Branch removed.");
      return filtered;
    });
  };

  const handleBranchChange = (index, field, value) => {
    setBranchRows((prev) =>
      prev.map((row, i) => {
        if (field === "CentralRuleMinWages") {
          return i === index ? { ...row, CentralRuleMinWages: value ? 1 : 0 } : row;
        }
        if (field === "IsContractor") {
          return i === index ? { ...row, IsContractor: value ? 1 : 0 } : row;
        }
        if (field === "PhoneMobileNo") {
          const cleanVal = String(value || "").replace(/\D/g, "").slice(0, 10);
          return i === index ? { ...row, PhoneMobileNo: cleanVal } : row;
        }
        return i === index ? { ...row, [field]: value } : row;
      })
    );
  };

  const handleSubmit = async (values) => {
    try {
      // Validate that all branch rows have a mandatory Branch Name and NO duplicates
      const seenBranchNames = new Set();
      for (let i = 0; i < branchRows.length; i++) {
        const bName = branchRows[i]?.Name?.trim();
        if (!bName) {
          alert(`Branch ${i + 1}: Branch Name is mandatory! Please enter Branch Name.`);
          setActiveTab("branches");
          return;
        }
        const lowerName = bName.toLowerCase();
        if (seenBranchNames.has(lowerName)) {
          alert(`Branch "${bName}" is duplicated! Duplicate branch names are not allowed for a firm.`);
          setActiveTab("branches");
          return;
        }
        seenBranchNames.add(lowerName);
      }

      const boolVal = (v) => Boolean(v === true || v === 1 || v === "1" || String(v).toLowerCase() === "true");
      const numVal = (v) => (v !== null && v !== undefined && v !== "" && !isNaN(Number(v)) ? Number(v) : 0);
      const strVal = (v) => (v !== null && v !== undefined ? String(v).trim() : "");

      const mainBranch = branchRows.find((b) => b.IsMainBranch === 1) || branchRows[0] || {};

      const formData = new FormData();
      // Main Information
      formData.append("Name", strVal(values.Name));
      formData.append("F_FirmType", numVal(values.F_FirmType));
      formData.append("PFNo", strVal(mainBranch.PFNo));
      formData.append("ESINo", strVal(mainBranch.ESINo));
      formData.append("NatureOfBusiness", strVal(values.NatureOfBusiness));
      formData.append("Signature", strVal(values.Signature));
      
      formData.append("PFUserName", strVal(mainBranch.PFUserName));
      formData.append("PFPassword", strVal(mainBranch.PFPassword));
      formData.append("ESIUserName", strVal(mainBranch.ESIUserName));
      formData.append("ESIPassword", strVal(mainBranch.ESIPassword));
      formData.append("FactoryActUserName", strVal(mainBranch.FactoryActUserName));
      formData.append("FactoryActPassword", strVal(mainBranch.FactoryActPassword));
      formData.append("EmploymentUserName", strVal(mainBranch.EmploymentUserName));
      formData.append("EmploymentPassword", strVal(mainBranch.EmploymentPassword));
      formData.append("LabourUserName", strVal(mainBranch.LabourUserName));
      formData.append("LabourPassword", strVal(mainBranch.LabourPassword));
      formData.append("OSHUserName", strVal(mainBranch.OSHUserName));
      formData.append("OSHPassword", strVal(mainBranch.OSHPassword));
      formData.append("ShramSuvidhaUserName", strVal(mainBranch.ShramSuvidhaUserName));
      formData.append("ShramSuvidhaPassword", strVal(mainBranch.ShramSuvidhaPassword));
      formData.append("SSOUserName", strVal(mainBranch.SSOUserName));
      formData.append("SSOPassword", strVal(mainBranch.SSOPassword));
      formData.append("IsNotInUse", boolVal(values.IsNotInUse));

      // Manager Information
      formData.append("ManagerName", strVal(values.ManagerName));
      formData.append("ManagerAddress", strVal(values.ManagerAddress));
      formData.append("IsContractor", boolVal(values.IsContractor));
      formData.append("PrincipleEmployer", strVal(values.PrincipleEmployer));
      formData.append("PrincipleEmployerAddress", strVal(values.PrincipleEmployerAddress));

      // Address
      formData.append("CoAddress", strVal(values.CoAddress));
      formData.append("CoOtherAddress", strVal(values.CoOtherAddress));
      formData.append("OfficeAddress", strVal(values.OfficeAddress));
      formData.append("OfficeAddressOther", strVal(values.OfficeAddressOther));
      formData.append("PhoneMobileNo", strVal(values.PhoneMobileNo));

      // Information
      formData.append("MaxWorkers", numVal(values.MaxWorkers));
      formData.append("UseOfPower", strVal(values.UseOfPower));
      formData.append("F_ConcernType", numVal(values.F_ConcernType));
      formData.append("F_PremisesType", numVal(values.F_PremisesType));
      formData.append("LicenceFee", numVal(values.LicenceFee));
      formData.append("DifferenceFee", numVal(values.DifferenceFee));
      formData.append("AmendmentFee", numVal(values.AmendmentFee));
      formData.append("DuplicateLicenceFee", numVal(values.DuplicateLicenceFee));
      formData.append("Connection", strVal(values.Connection));
      formData.append("LINNo", strVal(values.LINNo));
      formData.append("FBRegNo", strVal(values.FBRegNo));
      if (values.RegRenDate && String(values.RegRenDate).trim() !== "") {
        formData.append("RegRenDate", String(values.RegRenDate).split("T")[0]);
      }
      if (values.RegExpiryDate && String(values.RegExpiryDate).trim() !== "") {
        formData.append("RegExpiryDate", String(values.RegExpiryDate).split("T")[0]);
      }
      formData.append("InTime", strVal(values.InTime));
      formData.append("OutTime", strVal(values.OutTime));
      formData.append("CentralRuleMinWages", boolVal(values.CentralRuleMinWages));
      formData.append("Remark", strVal(values.Remark));

      // Firm In Hindi
      formData.append("FirmNameHindi", strVal(values.FirmNameHindi));
      formData.append("FirmAddressHindi", strVal(values.FirmAddressHindi));
      
      // Append Logo file only if uploaded as File object
      if (values.LogoFile instanceof File) {
        formData.append("Logo", values.LogoFile);
      }

      const sanitizedBranches = branchRows.map((b) => {
        const isThisMain = b.IsMainBranch === 1;
        const showPF = isThisMain || isMultiPF;
        const showESI = isThisMain || isMultiESI;
        return {
          ...b,
          IsMainBranch: isThisMain ? 1 : 0,
          RegRenDate: isThisMain ? (b.RegRenDate || values.RegRenDate || "").split("T")[0] : (b.RegRenDate ? String(b.RegRenDate).split("T")[0] : ""),
          RegExpiryDate: isThisMain ? (b.RegExpiryDate || values.RegExpiryDate || "").split("T")[0] : (b.RegExpiryDate ? String(b.RegExpiryDate).split("T")[0] : ""),
          PFNo: showPF ? (b.PFNo || "").trim() : "",
          ESINo: showESI ? (b.ESINo || "").trim() : "",
          PFUserName: showPF ? (b.PFUserName || "").trim() : "",
          PFPassword: showPF ? (b.PFPassword || "").trim() : "",
          ESIUserName: showESI ? (b.ESIUserName || "").trim() : "",
          ESIPassword: showESI ? (b.ESIPassword || "").trim() : "",
        };
      });
      formData.append("BranchJson", JSON.stringify(sanitizedBranches));
      formData.append("ShiftTimeJson", "[]");

      formData.append("CalenderFromDay", strVal(values.CalenderFromDay));
      formData.append("CalenderFromMonth", strVal(values.CalenderFromMonth));
      formData.append("CalenderToDay", strVal(values.CalenderToDay));
      formData.append("CalenderToMonth", strVal(values.CalenderToMonth));

      await Fn_AddEditData(
        dispatch,
        setState,
        { arguList: { id: state.id, formData } },
        API_URL_SAVE,
        true,
        "memberid",
        navigate,
        "/FirmMaster"
      ).catch((err) => {
        console.warn("Firm save rejected:", err);
      });
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  const tabs = [
    { key: "mainInfo", label: "Main Information" },
    { key: "manager", label: "Manager" },
    { key: "address", label: "Address" },
    { key: "information", label: "Information" },
    { key: "firmHindi", label: "Firm In Hindi" },
    { key: "branches", label: "Branches" },
  ];

  return (
    <Fragment>
      <PageTitle activeMenu="Masters" motherMenu="Masters" pageContent="Firm Master" />

      <div className="row">
        <div className="col-lg-12">
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">Firm Master</h4>
            </div>
            <div className="card-body">
              {/* Tabs Nav */}
              <ul className="nav nav-tabs mb-4" role="tablist">
                {tabs.map((tab) => (
                  <li className="nav-item" key={tab.key}>
                    <button
                      className={`nav-link${activeTab === tab.key ? " active" : ""}`}
                      type="button"
                      onClick={() => setActiveTab(tab.key)}
                    >
                      {tab.label}
                    </button>
                  </li>
                ))}
              </ul>

              <Formik
                initialValues={state.formData}
                enableReinitialize
                validationSchema={FirmSchema}
                onSubmit={(values, { setSubmitting }) => {
                  setTimeout(() => {
                    handleSubmit(values);
                    setSubmitting(false);
                  }, 400);
                }}
              >
                {({ values, errors, handleChange, handleBlur, handleSubmit, isSubmitting, setFieldValue }) => (
                  <form onSubmit={handleSubmit}>

                    {/* ── Tab 1: Main Information ── */}
                    {activeTab === "mainInfo" && (
                      <div>
                        <div className="row">
                          <div className="col-md-6 mb-3">
                            <label className="text-label">Firm Name *</label>
                            <input
                              type="text"
                              className="form-control"
                              name="Name"
                              placeholder="Enter Firm Name"
                              value={values.Name || ""}
                              onChange={handleChange}
                              onBlur={handleBlur}
                            />
                            {errors.Name && <div className="text-danger fs-12">{errors.Name}</div>}
                          </div>

                          <div className="col-md-6 mb-3">
                            <label className="text-label">Firm Type *</label>
                            <select
                              className="form-control"
                              name="F_FirmType"
                              value={values.F_FirmType || ""}
                              onChange={handleChange}
                              onBlur={handleBlur}
                            >
                              <option value="">-- Select Firm Type --</option>
                              {state.FirmType &&
                                state.FirmType
                                  .filter((item) => !item.IsNotInUse || String(item.Id) === String(values.F_FirmType))
                                  .map((item) => (
                                    <option key={item.Id} value={item.Id}>
                                      {item.Name}
                                    </option>
                                  ))}
                            </select>
                            {errors.F_FirmType && <div className="text-danger fs-12">{errors.F_FirmType}</div>}
                          </div>

                          <div className="col-md-6 mb-3">
                            <label className="text-label">Nature of Business</label>
                            <input
                              type="text"
                              className="form-control"
                              name="NatureOfBusiness"
                              placeholder="e.g. MARBLE GANGSAW & MINES"
                              value={values.NatureOfBusiness || ""}
                              onChange={handleChange}
                              onBlur={handleBlur}
                            />
                          </div>

                          <div className="col-md-6 mb-3">
                            <label className="text-label">Signature</label>
                            <input
                              type="text"
                              className="form-control"
                              name="Signature"
                              placeholder="e.g. MANAGER/DIRECTOR"
                              value={values.Signature || ""}
                              onChange={handleChange}
                              onBlur={handleBlur}
                            />
                          </div>

                          <div className="col-md-6 mb-3">
                            <label className="text-label">Firm Logo (75x75 px)</label>
                            <div className="d-flex align-items-center gap-3">
                              <input
                                type="file"
                                accept="image/*"
                                className="form-control"
                                style={{ padding: "3px 10px" }}
                                onChange={async (e) => {
                                  const file = e.currentTarget.files[0];
                                  if (file) {
                                    const result = await processImageToLogo(file);
                                    setFieldValue("LogoPreview", result.previewUrl);
                                    setFieldValue("LogoFile", result.file);
                                  }
                                }}
                              />
                              {(values.LogoPreview || values.Logo) ? (
                                <div className="position-relative" style={{ width: "75px", height: "75px", border: "2px dashed #4C6EF5", borderRadius: "8px", overflow: "hidden", background: "#f8f9fa", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                  <img
                                    src={values.LogoPreview || (values.Logo.startsWith('data:') || values.Logo.startsWith('http') ? values.Logo : `${API_WEB_URLS.IMAGEURL}/${values.Logo}`)}
                                    alt="Logo Preview"
                                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                  />
                                  <button
                                    type="button"
                                    className="btn btn-danger btn-xs position-absolute"
                                    style={{ bottom: "2px", right: "2px", padding: "1px 4px", fontSize: "10px" }}
                                    onClick={() => {
                                      setFieldValue("LogoPreview", "");
                                      setFieldValue("LogoFile", null);
                                      setFieldValue("Logo", "");
                                    }}
                                  >
                                    <i className="fa fa-times"></i>
                                  </button>
                                </div>
                              ) : (
                                <div style={{ width: "75px", height: "75px", border: "2px dashed #ccc", borderRadius: "8px", background: "#f8f9fa", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", fontSize: "9px", color: "#888", textAlign: "center", lineHeight: "11px" }}>
                                  <span>75 x 75</span>
                                  <span>Logo</span>
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="col-md-6 mb-3">
                            <label className="text-label">Calender Month (From - To)</label>
                            <div className="d-flex align-items-center gap-1">
                              {/* From Month */}
                              <select
                                className="form-control"
                                name="CalenderFromMonth"
                                value={values.CalenderFromMonth || ""}
                                onChange={(e) => {
                                  const newMonth = e.target.value;
                                  setFieldValue("CalenderFromMonth", newMonth);
                                  const maxD = getDaysInMonth(newMonth);
                                  if (Number(values.CalenderFromDay) > maxD) {
                                    setFieldValue("CalenderFromDay", String(maxD).padStart(2, "0"));
                                  }
                                }}
                                onBlur={handleBlur}
                                style={{ padding: "6px" }}
                              >
                                <option value="">-- From Month --</option>
                                {[
                                  "Jan", "Feb", "Mar", "Apr", "May", "Jun",
                                  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
                                ].map((month, idx) => {
                                  const mVal = String(idx + 1).padStart(2, "0");
                                  return <option key={mVal} value={mVal}>{month}</option>;
                                })}
                              </select>

                              {/* From Day */}
                              <select
                                className="form-control"
                                name="CalenderFromDay"
                                value={values.CalenderFromDay || ""}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                style={{ padding: "6px" }}
                              >
                                <option value="">-- Day --</option>
                                {Array.from({ length: getDaysInMonth(values.CalenderFromMonth) }, (_, i) => String(i + 1).padStart(2, "0")).map(day => (
                                  <option key={day} value={day}>{day}</option>
                                ))}
                              </select>

                              <span className="mx-1 text-muted fw-bold">to</span>

                              {/* To Month */}
                              <select
                                className="form-control"
                                name="CalenderToMonth"
                                value={values.CalenderToMonth || ""}
                                onChange={(e) => {
                                  const newMonth = e.target.value;
                                  setFieldValue("CalenderToMonth", newMonth);
                                  const maxD = getDaysInMonth(newMonth);
                                  if (Number(values.CalenderToDay) > maxD) {
                                    setFieldValue("CalenderToDay", String(maxD).padStart(2, "0"));
                                  }
                                }}
                                onBlur={handleBlur}
                                style={{ padding: "6px" }}
                              >
                                <option value="">-- To Month --</option>
                                {[
                                  "Jan", "Feb", "Mar", "Apr", "May", "Jun",
                                  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
                                ].map((month, idx) => {
                                  const mVal = String(idx + 1).padStart(2, "0");
                                  return <option key={mVal} value={mVal}>{month}</option>;
                                })}
                              </select>

                              {/* To Day */}
                              <select
                                className="form-control"
                                name="CalenderToDay"
                                value={values.CalenderToDay || ""}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                style={{ padding: "6px" }}
                              >
                                <option value="">-- Day --</option>
                                {Array.from({ length: getDaysInMonth(values.CalenderToMonth) }, (_, i) => String(i + 1).padStart(2, "0")).map(day => (
                                  <option key={day} value={day}>{day}</option>
                                ))}
                              </select>
                            </div>
                          </div>
                        </div>

                        <div className="form-check mt-3 mb-2">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="IsNotInUse"
                            name="IsNotInUse"
                            checked={Boolean(values.IsNotInUse)}
                            onChange={(e) => setFieldValue("IsNotInUse", e.target.checked)}
                          />
                          <label className="form-check-label fw-bold text-danger" htmlFor="IsNotInUse">
                            Firm Not in Use
                          </label>
                        </div>
                      </div>
                    )}

                    {/* ── Tab 2: Manager ── */}
                    {activeTab === "manager" && (
                      <div className="row">
                        <div className="col-md-12 mb-3">
                          <label className="text-label">Name (Manager Name)</label>
                          <input
                            type="text"
                            className="form-control"
                            name="ManagerName"
                            placeholder="Enter Manager Name (e.g. SHRI DASHRAT KISHORE VIJAYVARGI)"
                            value={values.ManagerName || ""}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                        </div>

                        <div className="col-md-12 mb-3">
                          <label className="text-label">Address (Manager Address)</label>
                          <textarea
                            className="form-control"
                            rows={3}
                            name="ManagerAddress"
                            placeholder="Enter Manager Address (e.g. SHRI KRISHNA NAGAR, KANKROLI, RAJSAMAND, (RAJ.))"
                            value={values.ManagerAddress || ""}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                        </div>

                        <div className="col-12 mb-3">
                          <div className="form-check">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id="IsContractor"
                              name="IsContractor"
                              checked={Boolean(values.IsContractor)}
                              onChange={(e) => setFieldValue("IsContractor", e.target.checked)}
                            />
                            <label className="form-check-label fw-bold" htmlFor="IsContractor">
                              Contractor
                            </label>
                          </div>
                        </div>

                        <div className="col-md-12 mb-3">
                          <label className="text-label">Principle Employer</label>
                          <input
                            type="text"
                            className="form-control"
                            name="PrincipleEmployer"
                            placeholder="Enter Principle Employer Name"
                            value={values.PrincipleEmployer || ""}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                        </div>

                        <div className="col-md-12 mb-3">
                          <label className="text-label">Principle Employer Address</label>
                          <textarea
                            className="form-control"
                            rows={3}
                            name="PrincipleEmployerAddress"
                            placeholder="Enter Principle Employer Address"
                            value={values.PrincipleEmployerAddress || ""}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                        </div>
                      </div>
                    )}

                    {/* ── Tab 3: Address ── */}
                    {activeTab === "address" && (
                      <div className="row">
                        <div className="col-md-6 mb-3">
                          <label className="text-label">Co. Address</label>
                          <textarea
                            className="form-control"
                            rows={3}
                            name="CoAddress"
                            placeholder="Enter Company / Registered Address"
                            value={values.CoAddress || ""}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                        </div>

                        <div className="col-md-6 mb-3">
                          <label className="text-label">Co. Other Address</label>
                          <textarea
                            className="form-control"
                            rows={3}
                            name="CoOtherAddress"
                            placeholder="Enter Company Other Address"
                            value={values.CoOtherAddress || ""}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                        </div>

                        <div className="col-md-6 mb-3">
                          <label className="text-label">Office Address</label>
                          <textarea
                            className="form-control"
                            rows={3}
                            name="OfficeAddress"
                            placeholder="Enter Office Address"
                            value={values.OfficeAddress || ""}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                        </div>

                        <div className="col-md-6 mb-3">
                          <label className="text-label">Office Address Other</label>
                          <textarea
                            className="form-control"
                            rows={3}
                            name="OfficeAddressOther"
                            placeholder="Enter Office Address Other"
                            value={values.OfficeAddressOther || ""}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                        </div>

                        <div className="col-md-6 mb-3">
                          <label className="text-label">Phone / Mobile No.</label>
                          <input
                            type="text"
                            className="form-control"
                            maxLength={10}
                            name="PhoneMobileNo"
                            placeholder="Enter 10-digit mobile or phone number"
                            value={values.PhoneMobileNo || ""}
                            onChange={(e) => {
                              const val = e.target.value.replace(/[^0-9]/g, "");
                              setFieldValue("PhoneMobileNo", val);
                            }}
                            onBlur={handleBlur}
                          />
                        </div>
                      </div>
                    )}

                    {/* ── Tab 4: Information ── */}
                    {activeTab === "information" && (
                      <div className="row">
                        <div className="col-md-4 mb-3">
                          <label className="text-label">Max. Workers</label>
                          <input
                            type="number"
                            className="form-control"
                            name="MaxWorkers"
                            value={values.MaxWorkers || ""}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                        </div>

                        <div className="col-md-4 mb-3">
                          <label className="text-label">Licence Fee</label>
                          <input
                            type="number"
                            className="form-control"
                            name="LicenceFee"
                            value={values.LicenceFee || ""}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                        </div>

                        <div className="col-md-4 mb-3">
                          <label className="text-label">Difference Fee</label>
                          <input
                            type="number"
                            className="form-control"
                            name="DifferenceFee"
                            value={values.DifferenceFee || ""}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                        </div>

                        <div className="col-md-4 mb-3">
                          <label className="text-label">Use of Power</label>
                          <input
                            type="text"
                            className="form-control"
                            name="UseOfPower"
                            value={values.UseOfPower || ""}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                        </div>

                        <div className="col-md-4 mb-3">
                          <label className="text-label">Connection</label>
                          <input
                            type="text"
                            className="form-control"
                            name="Connection"
                            placeholder="Connection details"
                            value={values.Connection || ""}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                        </div>

                        <div className="col-md-4 mb-3">
                          <label className="text-label">Type of Concern</label>
                          <select
                            className="form-control"
                            name="F_ConcernType"
                            value={values.F_ConcernType || ""}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          >
                            <option value="">-- Select Concern Type --</option>
                            {state.ConcernType &&
                              state.ConcernType
                                .filter((item) => !isNotInUse(item) || String(item.Id) === String(values.F_ConcernType))
                                .map((item) => (
                                  <option key={item.Id} value={item.Id}>
                                    {item.Name}
                                  </option>
                                ))}
                          </select>
                        </div>

                        <div className="col-md-4 mb-3">
                          <label className="text-label">Type of Premises</label>
                          <select
                            className="form-control"
                            name="F_PremisesType"
                            value={values.F_PremisesType || ""}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          >
                            <option value="">-- Select Premises Type --</option>
                            {state.PremisesType &&
                              state.PremisesType
                                .filter((item) => !item.IsNotInUse || String(item.Id) === String(values.F_PremisesType))
                                .map((item) => (
                                  <option key={item.Id} value={item.Id}>
                                    {item.Name}
                                  </option>
                                ))}
                          </select>
                        </div>

                        <div className="col-md-4 mb-3">
                          <label className="text-label">Reg. / Ren. Date</label>
                          <input
                            type="date"
                            className="form-control"
                            name="RegRenDate"
                            value={values.RegRenDate ? values.RegRenDate.split("T")[0] : ""}
                            onChange={(e) => {
                              const val = e.target.value;
                              setFieldValue("RegRenDate", val);
                              setBranchRows((prev) =>
                                prev.map((b, i) => (i === 0 ? { ...b, RegRenDate: val } : b))
                              );
                            }}
                            onBlur={handleBlur}
                          />
                        </div>

                        <div className="col-md-4 mb-3">
                          <label className="text-label">Reg Expiry Date</label>
                          <input
                            type="date"
                            className="form-control"
                            name="RegExpiryDate"
                            value={values.RegExpiryDate ? values.RegExpiryDate.split("T")[0] : ""}
                            onChange={(e) => {
                              const val = e.target.value;
                              setFieldValue("RegExpiryDate", val);
                              setBranchRows((prev) =>
                                prev.map((b, i) => (i === 0 ? { ...b, RegExpiryDate: val } : b))
                              );
                            }}
                            onBlur={handleBlur}
                          />
                        </div>

                        <div className="col-md-4 mb-3">
                          <label className="text-label">Amendment Fee</label>
                          <input
                            type="number"
                            className="form-control"
                            name="AmendmentFee"
                            value={values.AmendmentFee || ""}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                        </div>

                        <div className="col-md-4 mb-3">
                          <label className="text-label">Duplicate Lic. Fee</label>
                          <input
                            type="number"
                            className="form-control"
                            name="DuplicateLicenceFee"
                            value={values.DuplicateLicenceFee || ""}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                        </div>

                        <div className="col-md-4 mb-3">
                          <label className="text-label">FB Reg. No.</label>
                          <input
                            type="text"
                            className="form-control"
                            name="FBRegNo"
                            value={values.FBRegNo || ""}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                        </div>

                        <div className="col-md-4 mb-3">
                          <label className="text-label">LIN No</label>
                          <input
                            type="text"
                            className="form-control"
                            name="LINNo"
                            value={values.LINNo || ""}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                        </div>

                        <div className="col-md-4 mb-3">
                          <label className="text-label">In Time</label>
                          <input
                            type="text"
                            className="form-control"
                            name="InTime"
                            placeholder="e.g. 09:00 AM"
                            value={values.InTime || ""}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                        </div>

                        <div className="col-md-4 mb-3">
                          <label className="text-label">Out Time</label>
                          <input
                            type="text"
                            className="form-control"
                            name="OutTime"
                            placeholder="e.g. 06:00 PM"
                            value={values.OutTime || ""}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                        </div>

                        <div className="col-12 mb-3">
                          <div className="form-check">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id="CentralRuleMinWages"
                              name="CentralRuleMinWages"
                              checked={Boolean(values.CentralRuleMinWages)}
                              onChange={(e) => setFieldValue("CentralRuleMinWages", e.target.checked)}
                            />
                            <label className="form-check-label fw-bold" htmlFor="CentralRuleMinWages">
                              Central Rule in Min Wages
                            </label>
                          </div>
                        </div>

                        <div className="col-12 mb-3">
                          <label className="text-label">Remark</label>
                          <textarea
                            className="form-control"
                            name="Remark"
                            rows={3}
                            placeholder="Enter remarks..."
                            value={values.Remark || ""}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                        </div>
                      </div>
                    )}

                    {/* ── Tab 5: Firm In Hindi ── */}
                    {activeTab === "firmHindi" && (
                      <div className="row">
                        <div className="col-md-6 mb-3">
                          <label className="text-label">Firm Name (Hindi)</label>
                          <input
                            type="text"
                            className="form-control"
                            name="FirmNameHindi"
                            placeholder="फर्म का नाम (हिन्दी में)"
                            value={values.FirmNameHindi || ""}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                        </div>

                        <div className="col-md-6 mb-3">
                          <label className="text-label">Firm Address (Hindi)</label>
                          <textarea
                            className="form-control"
                            rows={3}
                            name="FirmAddressHindi"
                            placeholder="फर्म का पता (हिन्दी में)"
                            value={values.FirmAddressHindi || ""}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                        </div>
                      </div>
                    )}

                    {/* ── Tab 6: Branches ── */}
                    {activeTab === "branches" && (
                      <div>
                        <div className="d-flex justify-content-end mb-3">
                          <button type="button" className="btn btn-success btn-sm" onClick={addBranchRow}>
                            <i className="fa fa-plus me-1"></i>Add Branch
                          </button>
                        </div>
                        {branchRows.map((row, index) => {
                          const isMain = row.IsMainBranch === 1;
                          const showPF = isMain || isMultiPF;
                          const showESI = isMain || isMultiESI;
                          const rowKey = row._uid || (row.Id ? `b_${row.Id}` : `idx_${index}`);

                          return (
                            <div key={rowKey} className="card border mb-3 shadow-sm">
                              <div className="card-header d-flex justify-content-between align-items-center py-2" style={{ backgroundColor: isMain ? "#f8faff" : "#ffffff" }}>
                                <div className="d-flex align-items-center">
                                  <strong>Branch {index + 1}{row.Name ? ` — ${row.Name}` : ""}</strong>
                                  {isMain && (
                                    <span className="badge badge-sm badge-primary ms-2">
                                      <i className="fa fa-star me-1"></i>Main Branch
                                    </span>
                                  )}
                                </div>
                                {!isMain && (
                                  <button
                                    type="button"
                                    className="btn btn-danger btn-xs"
                                    title="Remove Branch"
                                    onClick={() => removeBranchRow(row._uid)}
                                  >
                                    <i className="fa fa-minus me-1"></i>Remove
                                  </button>
                                )}
                              </div>
                            <div className="card-body">
                              {/* Basic */}
                              <h6 className="text-primary border-bottom pb-1 mb-3">Basic Info & Address</h6>
                              <div className="row">
                                <div className="col-md-4 mb-3">
                                  <label className="text-label">Branch Name <span className="text-danger">*</span></label>
                                  <input 
                                    type="text" 
                                    className={`form-control ${!row.Name?.trim() ? "border-danger" : ""}`}
                                    placeholder="Enter branch name (e.g. Main Branch / Unit 1)" 
                                    value={row.Name} 
                                    onChange={(e) => handleBranchChange(index, "Name", e.target.value)} 
                                  />
                                  {!row.Name?.trim() && (
                                    <div className="text-danger fs-12 mt-1">Branch name is required</div>
                                  )}
                                </div>
                                <div className="col-md-4 mb-3">
                                  <label className="text-label">C/O Address</label>
                                  <input type="text" className="form-control" value={row.CoAddress} onChange={(e) => handleBranchChange(index, "CoAddress", e.target.value)} />
                                </div>
                                <div className="col-md-4 mb-3">
                                  <label className="text-label">C/O Other Address</label>
                                  <input type="text" className="form-control" value={row.CoOtherAddress} onChange={(e) => handleBranchChange(index, "CoOtherAddress", e.target.value)} />
                                </div>
                                <div className="col-md-4 mb-3">
                                  <label className="text-label">Office Address</label>
                                  <input type="text" className="form-control" value={row.OfficeAddress} onChange={(e) => handleBranchChange(index, "OfficeAddress", e.target.value)} />
                                </div>
                                <div className="col-md-4 mb-3">
                                  <label className="text-label">Office Address Other</label>
                                  <input type="text" className="form-control" value={row.OfficeAddressOther} onChange={(e) => handleBranchChange(index, "OfficeAddressOther", e.target.value)} />
                                </div>
                                <div className="col-md-4 mb-3">
                                  <label className="text-label">Phone / Mobile No</label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    maxLength={10}
                                    placeholder="Enter 10-digit mobile/phone"
                                    value={row.PhoneMobileNo}
                                    onChange={(e) => {
                                      const val = e.target.value.replace(/[^0-9]/g, "");
                                      handleBranchChange(index, "PhoneMobileNo", val);
                                    }}
                                  />
                                </div>
                                <div className="col-md-4 mb-3 d-flex align-items-center mt-2">
                                  <div className="form-check">
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      id={`IsMainBranch_${rowKey}`}
                                      checked={isMain}
                                      onChange={(e) => {
                                        if (e.target.checked) {
                                          setAsMainBranch(row._uid, values);
                                        } else {
                                          toast.info("A firm must have one Main Branch. To change, check Main Branch on another branch.");
                                        }
                                      }}
                                    />
                                    <label className="form-check-label fw-bold" htmlFor={`IsMainBranch_${rowKey}`} style={{ cursor: "pointer" }}>
                                      Main Branch {isMain ? "(Active)" : ""}
                                    </label>
                                  </div>
                                </div>
                                <div className="col-md-4 mb-3 d-flex align-items-center mt-2">
                                  <div className="form-check">
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      id={`CentralRuleMinWages_${index}`}
                                      checked={row.CentralRuleMinWages === 1}
                                      onChange={(e) => handleBranchChange(index, "CentralRuleMinWages", e.target.checked)}
                                    />
                                    <label className="form-check-label" htmlFor={`CentralRuleMinWages_${index}`}>Central Rule Min Wages</label>
                                  </div>
                                </div>
                              </div>

                              {/* Manager Info for Branch */}
                              <h6 className="text-primary border-bottom pb-1 mb-3 mt-2">Manager & Principal Employer</h6>
                              <div className="row">
                                <div className="col-md-6 mb-3">
                                  <label className="text-label">Manager Name</label>
                                  <input type="text" className="form-control" value={row.ManagerName} onChange={(e) => handleBranchChange(index, "ManagerName", e.target.value)} />
                                </div>
                                <div className="col-md-6 mb-3">
                                  <label className="text-label">Manager Address</label>
                                  <input type="text" className="form-control" value={row.ManagerAddress} onChange={(e) => handleBranchChange(index, "ManagerAddress", e.target.value)} />
                                </div>
                                <div className="col-md-4 mb-3 d-flex align-items-center">
                                  <div className="form-check">
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      id={`IsContractor_${index}`}
                                      checked={row.IsContractor === 1}
                                      onChange={(e) => handleBranchChange(index, "IsContractor", e.target.checked)}
                                    />
                                    <label className="form-check-label" htmlFor={`IsContractor_${index}`}>Contractor</label>
                                  </div>
                                </div>
                                <div className="col-md-4 mb-3">
                                  <label className="text-label">Principle Employer</label>
                                  <input type="text" className="form-control" value={row.PrincipleEmployer} onChange={(e) => handleBranchChange(index, "PrincipleEmployer", e.target.value)} />
                                </div>
                                <div className="col-md-4 mb-3">
                                  <label className="text-label">Principle Employer Address</label>
                                  <input type="text" className="form-control" value={row.PrincipleEmployerAddress} onChange={(e) => handleBranchChange(index, "PrincipleEmployerAddress", e.target.value)} />
                                </div>
                              </div>

                              {/* Branch PF & ESI Configuration */}
                              {showPF || showESI ? (
                                <div className="p-3 mb-3 rounded" style={{ backgroundColor: "#f8f9fa", border: "1px solid #cce5ff" }}>
                                  <h6 className="text-primary border-bottom pb-1 mb-3 fw-bold d-flex align-items-center">
                                    <span>Branch PF & ESI Details</span>
                                    {isMain ? (
                                      <span className="badge badge-sm badge-primary light ms-2">
                                        Main Branch
                                      </span>
                                    ) : (
                                      <span className="badge badge-sm badge-info light ms-2">
                                        {isMultiPF && isMultiESI ? "Multi PF & ESI Enabled" : isMultiPF ? "Multi PF Enabled" : "Multi ESI Enabled"}
                                      </span>
                                    )}
                                  </h6>
                                  <div className="row">
                                    {showPF && (
                                      <div className={`${showESI ? "col-md-6" : "col-md-12"} mb-3`}>
                                        <label className="text-label fw-bold text-dark">
                                          Branch PF No {isMain && !isMultiPF ? "(Main Branch)" : ""}
                                        </label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="Enter Branch PF No (e.g. RJUDR0008696000)"
                                          value={row.PFNo || ""}
                                          onChange={(e) => handleBranchChange(index, "PFNo", e.target.value)}
                                        />
                                      </div>
                                    )}
                                    {showESI && (
                                      <div className={`${showPF ? "col-md-6" : "col-md-12"} mb-3`}>
                                        <label className="text-label fw-bold text-dark">
                                          Branch ESI No {isMain && !isMultiESI ? "(Main Branch)" : ""}
                                        </label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="Enter Branch ESI No (e.g. 16000206590000403)"
                                          value={row.ESINo || ""}
                                          onChange={(e) => handleBranchChange(index, "ESINo", e.target.value)}
                                        />
                                      </div>
                                    )}
                                  </div>
                                </div>
                              ) : (
                                <div className="p-2 mb-3 rounded bg-light border text-muted fs-12">
                                  <i className="fa fa-info-circle me-1 text-info"></i>
                                  PF & ESI details for this branch are managed under the <strong>Main Branch</strong> (Multi PF / Multi ESI is not enabled).
                                </div>
                              )}

                              {/* Registration */}
                              <h6 className="text-primary border-bottom pb-1 mb-3 mt-2">Registration & Additional</h6>
                              <div className="row">
                                <div className="col-md-3 mb-3">
                                  <label className="text-label">LIN No</label>
                                  <input type="text" className="form-control" value={row.LINNo} onChange={(e) => handleBranchChange(index, "LINNo", e.target.value)} />
                                </div>
                                <div className="col-md-3 mb-3">
                                  <label className="text-label">FB Reg No</label>
                                  <input type="text" className="form-control" value={row.FBRegNo} onChange={(e) => handleBranchChange(index, "FBRegNo", e.target.value)} />
                                </div>
                                <div className="col-md-3 mb-3">
                                  <label className="text-label">Connection</label>
                                  <input type="text" className="form-control" value={row.Connection} onChange={(e) => handleBranchChange(index, "Connection", e.target.value)} />
                                </div>
                                <div className="col-md-3 mb-3">
                                  <label className="text-label">Reg / Renewal Date</label>
                                  <input type="date" className="form-control" value={row.RegRenDate ? row.RegRenDate.split("T")[0] : ""} onChange={(e) => handleBranchChange(index, "RegRenDate", e.target.value)} />
                                </div>
                                <div className="col-md-3 mb-3">
                                  <label className="text-label">Reg Expiry Date</label>
                                  <input type="date" className="form-control" value={row.RegExpiryDate ? row.RegExpiryDate.split("T")[0] : ""} onChange={(e) => handleBranchChange(index, "RegExpiryDate", e.target.value)} />
                                </div>
                                <div className="col-md-3 mb-3">
                                  <label className="text-label">Branch Name (Hindi)</label>
                                  <input type="text" className="form-control" value={row.FirmNameHindi} onChange={(e) => handleBranchChange(index, "FirmNameHindi", e.target.value)} />
                                </div>
                                <div className="col-md-6 mb-3">
                                  <label className="text-label">Branch Address (Hindi)</label>
                                  <input type="text" className="form-control" value={row.FirmAddressHindi} onChange={(e) => handleBranchChange(index, "FirmAddressHindi", e.target.value)} />
                                </div>
                              </div>

                              {/* Credentials */}
                              <h6 className="text-primary border-bottom pb-1 mb-3 mt-2">Credentials</h6>
                              <div className="row">
                                {[
                                  ...(showPF ? [{ label: "PF Portal", user: "PFUserName", pass: "PFPassword" }] : []),
                                  ...(showESI ? [{ label: "ESI Portal", user: "ESIUserName", pass: "ESIPassword" }] : []),
                                  { label: "Factory Act",   user: "FactoryActUserName",   pass: "FactoryActPassword" },
                                  { label: "Employment",    user: "EmploymentUserName",   pass: "EmploymentPassword" },
                                  { label: "Labour",        user: "LabourUserName",       pass: "LabourPassword" },
                                  { label: "OSH",           user: "OSHUserName",          pass: "OSHPassword" },
                                  { label: "Shram Suvidha", user: "ShramSuvidhaUserName", pass: "ShramSuvidhaPassword" },
                                  { label: "SSO",           user: "SSOUserName",          pass: "SSOPassword" },
                                ].map(({ label, user, pass }) => (
                                  <Fragment key={label}>
                                    <div className="col-12 mb-1"><small className="text-muted fw-semibold">{label}</small></div>
                                    <div className="col-md-3 mb-3">
                                      <label className="text-label">Username</label>
                                      <input type="text" className="form-control" value={row[user]} onChange={(e) => handleBranchChange(index, user, e.target.value)} />
                                    </div>
                                    <div className="col-md-3 mb-3">
                                      <label className="text-label">Password</label>
                                      <input type="text" className="form-control" value={row[pass]} onChange={(e) => handleBranchChange(index, pass, e.target.value)} />
                                    </div>
                                  </Fragment>
                                ))}
                              </div>
                            </div>
                          </div>
                        ); })}
                      </div>
                    )}

                    {/* ── Submit / Cancel ── */}
                    <div className="mt-4">
                      <button type="submit" className="btn btn-primary me-2" disabled={isSubmitting}>
                        {isSubmitting ? "Saving..." : "Save"}
                      </button>
                      {state.id > 0 && (
                        <button
                          type="button"
                          className="btn btn-danger me-2"
                          onClick={async () => {
                            if (window.confirm(`Are you sure you want to delete firm "${values.Name || state.id}"?`)) {
                              try {
                                await Fn_DeleteData(dispatch, () => {}, Number(state.id), `${API_WEB_URLS.MASTER}/0/token/FirmMaster`);
                                toast.success("Firm deleted successfully");
                                navigate("/FirmMaster");
                              } catch (err) {
                                console.error("Error deleting firm:", err);
                              }
                            }
                          }}
                        >
                          Delete
                        </button>
                      )}
                      <button
                        type="button"
                        className="btn btn-danger light"
                        onClick={() => navigate("/FirmMaster")}
                      >
                        Cancel
                      </button>
                    </div>
                  </form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default AddEdit_FirmMaster;
